import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { Location } from "@angular/common";

@Component({
  templateUrl: "./not-found.page.html",
  styleUrls: ["./not-found.page.scss"],
})
export class NotFoundPage {}
